var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowThumbnail)?_c('thumbnail',{attrs:{"src":_vm.src,"alt":_vm.attachedFile.original_filename,"max-height":"10rem"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }